import type { ReactNode } from 'react'

/** The minimal chrome for pages a visitor sees WITHOUT a staff session —
 *  password reset/set and the customer portal: the brand mark and whatever
 *  the page puts on the right, no staff navigation. */
export function AnonymousShell({ children, right }: { children: ReactNode; right?: ReactNode }) {
  return (
    <div className="app-layout">
      <header className="app-header">
        <span className="brand" aria-label="AllCode">
          <img src="/brand/allcode-logo.png" alt="AllCode" />
          <span className="product">Assessments</span>
        </span>
        {right}
      </header>
      <main className="app-main">{children}</main>
    </div>
  )
}
